/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { QueryByIdsPaymentRequests200ResponseInnerRequestor } from './query-by-ids-payment-requests200-response-inner-requestor';
// May contain unused imports in some cases
// @ts-ignore
import { QueryByIdsPaymentRequests200ResponseInnerSupplier } from './query-by-ids-payment-requests200-response-inner-supplier';

/**
 * 
 * @export
 * @interface QueryByIdsPaymentRequests200ResponseInner
 */
export interface QueryByIdsPaymentRequests200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'serialNumber': string;
    /**
     * 
     * @type {QueryByIdsPaymentRequests200ResponseInnerSupplier}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'supplier': QueryByIdsPaymentRequests200ResponseInnerSupplier;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'transferFeeResponsibility': QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'withholdingCalculatingMethod': QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'status': QueryByIdsPaymentRequests200ResponseInnerStatusEnum;
    /**
     * 
     * @type {QueryByIdsPaymentRequests200ResponseInnerRequestor}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'requestor': QueryByIdsPaymentRequests200ResponseInnerRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'requestedAt': string;
    /**
     * If bank transfer data has already been created, return the ID. Otherwise, null.
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'bankTransferId': string | null;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'invoiceEvidenceId': string;
}

export const QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = typeof QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum[keyof typeof QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum];
export const QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = typeof QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum[keyof typeof QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum];
export const QueryByIdsPaymentRequests200ResponseInnerStatusEnum = {
    pendingWorkflowCompletion: 'PENDING_WORKFLOW_COMPLETION',
    canceled: 'CANCELED',
    payable: 'PAYABLE',
    attachedToBankTransfer: 'ATTACHED_TO_BANK_TRANSFER',
    deactivated: 'DEACTIVATED'
} as const;

export type QueryByIdsPaymentRequests200ResponseInnerStatusEnum = typeof QueryByIdsPaymentRequests200ResponseInnerStatusEnum[keyof typeof QueryByIdsPaymentRequests200ResponseInnerStatusEnum];


